import React from 'react'

const NoDataFound = () => {
    return (
        <div className="no-data-sec">
            <img src={window.location.origin + "/images/landing-page/no-data.png"} className="no-data-img" />
            <h4>No data Found</h4>
            <div class="default-btn-sec"><a class="default-btn" href="/shop">Continue Shopping</a></div>
        </div>
    )
}

export default NoDataFound